globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useCallback, useEffect, useState } from 'react';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import { ModalDesktop } from './desktop/modal-desktop';
import { ModalMobile } from './mobile/modal-mobile';
import { ModalHeader } from './modal-header';
import { ModalContent } from './modal-content';
import { jsx as _jsx } from "react/jsx-runtime";
export function Modal(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      layout = _ref.layout,
      _ref$drawerProps = _ref.drawerProps,
      drawerProps = _ref$drawerProps === void 0 ? {} : _ref$drawerProps,
      _ref$modalProps = _ref.modalProps,
      modalProps = _ref$modalProps === void 0 ? {} : _ref$modalProps,
      isControlled = _ref.isControlled,
      variant = _ref.variant,
      onClose = _ref.onClose,
      haltGestures = _ref.haltGestures;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var _useState = useState(isOpen),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  useEffect(function () {
    if (isControlled) {
      setOpenModal(isOpen);
    }
  }, [setOpenModal, isControlled, isOpen]);
  var handleToggleModal = useCallback(function () {
    setOpenModal(!openModal);
  }, [setOpenModal, openModal]);
  return isDesktop ? /*#__PURE__*/_jsx(ModalDesktop, {
    variant: variant,
    isOpen: isControlled ? openModal : isOpen,
    layout: layout,
    onClose: isControlled ? handleToggleModal : onClose,
    modalProps: modalProps,
    drawerProps: drawerProps,
    children: children
  }) : /*#__PURE__*/_jsx(ModalMobile, {
    isOpen: isOpen,
    onClose: isControlled ? handleToggleModal : onClose,
    variant: variant,
    haltGestures: haltGestures,
    children: children
  });
}
export default Modal;
export var ModalOverlay = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal__ModalOverlay",
  componentId: "sc-1ifb0rr-0"
})(["", " ", ";"], {
  "position": "fixed",
  "overflow": "hidden"
}, function (_ref2) {
  var show = _ref2.show;
  return show && {
    "left": "0px",
    "top": "0px",
    "zIndex": "50",
    "height": "100%",
    "width": "100%",
    "--tw-bg-opacity": "0.3",
    "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
  };
});
export { ModalHeader, ModalContent };